<template>
  <div
    class="article-recipe-block"
    :class="{'in-list': inList}"
  >
    <div class="article-recipe-block__image-wrapper">
      <cloudinary-picture
        :url="imageUrl"
        :sizes="dimensions"
        :aspect-ratio="aspectRatio"
        :sharpen="80"
        auto-quality="best"
        :use-picture="true"
        :alt="recipe.title"
        class="article-recipe-block__image"
      />
      <save-recipe-button-wrapper
        :recipe="recipe"
        :is-saved="recipe.userInteraction && recipe.userInteraction.recipeSaved"
        :button-size="40"
      />
    </div>
    <h3 class="font-rubrik-3--light article-recipe-block__title">
      {{ title || recipe.title }}
    </h3>
    <recipe-content-attributes
      :customer-rating="recipe.userInteraction && recipe.userInteraction.customerRate"
      :average-rating="recipe.rating.averageRating"
      :number-of-votes="recipe.rating.numberOfVotes"
      :number-of-comments="recipe.numberOfComments"
      :is-good-climate-choice="recipe.isGoodClimateChoice"
    />
    <div class="article-recipe-block__preamble">
      <wysiwyg
        v-if="content"
        :content="content"
      />
      <template v-else>
        {{ recipe.preamble }}
      </template>
    </div>
    <link-wrapper
      class="image-text-block--button  article-recipe-block__button"
      :url="recipe.url"
      :title="recipe.title"
      :tracking="{
        event: 'recipeSelect',
        recipeId: String(recipe.id),
        recipeName: recipe.title,
        ...tracking
      }"
    />
  </div>
</template>

<script>
  import RecipeContentAttributes from '@/vue/components/recipes/recipeContentAttributes.vue'
  import SaveRecipeButtonWrapper from '@/vue/components/recipes/saveRecipeButtonWrapper'
  import "#/Communication/Comment"
  import "#/Climate/ClimateGuide"
  import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'

  export default {
    name: "ArticleRecipeBlock",
    components: {
      linkWrapper,
      RecipeContentAttributes,
      SaveRecipeButtonWrapper
    },
    props: {
      recipe: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      },
      inList: {
        type: Boolean,
        default: false
      },
      tracking: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        dimensions: {
          small: {
            width: 767,
            ar: 1.334763948
          },
          medium: {
            width: 712,
            ar: 1.92405063291
          },
          large: {
            width: 720,
            ar: 1.92405063291
           }
        },
        recipeIsSaved: false,
        isMounted: false,
      }
    },
    computed: {
      imageUrl () {
        const r = this.recipe
        if(r.imageUrl) {
          return r.imageUrl
        } else if (r.images && r.images.length) {
          for (let i = 0; i < r.images.length; i++) {
            if(r.images[i].size === 'default'){
              return r.images[i].url
            }
          }
          return r.images[0].url
        }
        return ''
      },
      aspectRatio () {
        return this.$root.isSmallViewport ? 74.91961414790997 : 51.86721991701245
      }
    }
  }
</script>

<style lang="scss">
.article-recipe-block {
  margin-bottom: 2.5rem;

  &__image-wrapper {
    position: relative;
    display: inline-block;
    height: auto;
    width: 100%;

    @include media-breakpoint-up(md) {
      margin-right: 1rem;
    }

    @include media-breakpoint-up(xl) {
      margin-right: 1.5rem;
    }
  }

  &__image {
    display: block;
    margin-bottom: 1.5rem;
    border-radius: 0.25rem;
    height: 100%;
  }

  // Override recipeContentAttribute-component
  .recipe-content-attr {
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: wrap;
    margin-bottom: 1.5rem;
  }

  &__title {
    display: block;
    margin: 0 0 0.5rem;
  }

  &__preamble {
    line-height: 1.5rem;
    margin-bottom: 1.5rem;
  }
}
</style>
